import permissionNames from "../../common/auth/access-control/permissionNames";
import {
  CurrentLocationDto,
  TrailerGpsLocationDto,
} from "../../common/data/service-proxies";

interface SelectedMarkerInfo {
  isTruck: boolean;
}

export interface SelectedTruck extends SelectedMarkerInfo {
  truckOrTrailer: CurrentLocationDto;
}

interface SelectedTrailer extends SelectedMarkerInfo {
  truckOrTrailer: TrailerGpsLocationDto;
}

export type SelectedMarker = SelectedTruck | SelectedTrailer;

export const isTruck = (marker: SelectedMarker): marker is SelectedTruck => {
  return marker.isTruck;
};

export const dashboards = [
  { id: "locations", name: "Locations" },
  { id: "maintenance", name: "Maintenance" },
  { id: "safety", name: "Safety" },
];

interface IDashboardPermissions {
  [key: string]: string[];
}

export const dashboardPermissions: IDashboardPermissions = {
  locations: [permissionNames.locations.current.main],
  maintenance: [permissionNames.assets.maintenance.main],
  safety: [permissionNames.safety.alerts.main],
};

export interface IDashboardMapSettings {
  clusteringEnabled?: boolean;
}